import {CardContent, styled} from '@mui/material';

const StyledCardContent = styled(CardContent)`
	&:last-child {
		padding-bottom: 16px;
	}
`;

export {StyledCardContent};
